import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { ButtonProps } from '@material-ui/core';
import { ButtonLoading } from '../../../form/components/button-loading/button-loading';
import { BuyProcessUtils } from '../../index';

const useStyles = makeStyles((theme) => ({
  submitButton: {
    marginTop: theme.spacing(4),
  },
}));

export type SubmitButtonProps = ButtonProps & {
  loading?: boolean;
  gutter?: boolean;
};

export const SubmitButton = ({
  children,
  className,
  gutter = true,
  ...rest
}: SubmitButtonProps) => {
  const classes = useStyles();
  const isVerticalStepper = BuyProcessUtils.useIsVerticalStepper();

  return (
    <ButtonLoading
      variant="contained"
      color="primary"
      {...rest}
      className={classNames(gutter && classes.submitButton, className)}
      size="medium"
      type="submit"
      fullWidth={rest.fullWidth || isVerticalStepper}
    >
      {children}
    </ButtonLoading>
  );
};
